import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { createUnifiedTheme, UnifiedThemeProvider } from '@backstage/theme';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import {
  darkPageTheme,
  darkPalette,
  lightPageTheme,
  lightPalette,
} from './palettes';
import { buildComponentOverrides } from './components';
import { typography } from './typography';

// Overrides dos themes default do plugin-app (ids `theme:app/light` e
// `theme:app/dark`, ver AppThemeApi em @backstage/plugin-app). Um módulo
// registrado com pluginId: 'app' e um ThemeBlueprint.make({ name: 'light' | 'dark' })
// gera exatamente esses ids — o resolver do NFS substitui a extensão original
// pela do módulo (mesmo id = override), igual acontece hoje com o SignInPage
// em modules/auth.
const lightTheme = createUnifiedTheme({
  palette: lightPalette,
  defaultPageTheme: 'home',
  pageTheme: lightPageTheme,
  typography,
  components: buildComponentOverrides('light'),
});

const darkTheme = createUnifiedTheme({
  palette: darkPalette,
  defaultPageTheme: 'home',
  pageTheme: darkPageTheme,
  typography,
  components: buildComponentOverrides('dark'),
});

const lightThemeExtension = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Light Theme',
      variant: 'light',
      icon: <LightIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={lightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const darkThemeExtension = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Dark Theme',
      variant: 'dark',
      icon: <DarkIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={darkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [lightThemeExtension, darkThemeExtension],
});
